// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".imgBox[data-v-5c83f178]{display:flex;justify-content:center}.imgBox img[data-v-5c83f178]{width:270px;height:218px}.imgBox img[data-v-5c83f178],.stx[data-v-5c83f178]{text-align:center}.stx[data-v-5c83f178]{font-weight:700;font-size:24px;color:#404040;margin:30px 0 10px 0}.grtx[data-v-5c83f178]{text-align:center;font-weight:400;font-size:14px;color:#333}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
